import { Link } from 'react-router-dom';
import { categories, products } from '@/mocks/products';

const categoryImages: Record<string, string> = {
  'body-care': 'https://readdy.ai/api/search-image?query=Elegant%20luxury%20spa%20body%20care%20products%20arranged%20on%20a%20cream%20marble%20surface%2C%20massage%20oils%20and%20candles%2C%20soft%20warm%20lighting%2C%20premium%20cosmetic%20photography%2C%20rose%20gold%20accents%2C%20minimalist%20aesthetic&width=800&height=600&seq=cat-bodycare-01&orientation=landscape',
  'accessories': 'https://readdy.ai/api/search-image?query=Elegant%20silk%20and%20lace%20accessories%20on%20a%20velvet%20surface%2C%20luxurious%20textures%2C%20deep%20burgundy%20and%20cream%20tones%2C%20sophisticated%20boudoir%20product%20photography%2C%20soft%20dramatic%20lighting&width=800&height=600&seq=cat-accessories-02&orientation=landscape',
  'games': 'https://readdy.ai/api/search-image?query=Elegant%20couples%20board%20games%20and%20dice%20in%20rose%20gold%20finish%20on%20a%20dark%20velvet%20surface%2C%20premium%20game%20accessories%2C%20sophisticated%20intimate%20product%20photography%2C%20warm%20ambient%20lighting&width=800&height=600&seq=cat-games-03&orientation=landscape',
  'devices': 'https://readdy.ai/api/search-image?query=Sleek%20modern%20wellness%20device%20in%20rose%20gold%20finish%20on%20a%20minimalist%20cream%20surface%2C%20premium%20tech%20product%20photography%2C%20clean%20sophisticated%20aesthetic%2C%20soft%20diffused%20lighting&width=800&height=600&seq=cat-devices-04&orientation=landscape',
};

function getCategoryCount(catId: string): number {
  return products.filter((p) => p.category === catId).length;
}

export default function CategoryNav() {
  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label text-secondary-500 tracking-[0.2em] uppercase mb-2">
            Browse Categories
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
            按分类浏览
          </h2>
          <p className="mt-2 text-sm text-foreground-600 max-w-md mx-auto">
            探索我们精心划分的产品类别，快速找到心仪之选
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.filter((c) => c.id !== 'all').map((cat) => (
            <Link
              key={cat.id}
              to={`/category`}
              className="group relative rounded-lg overflow-hidden aspect-[4/3] cursor-pointer"
            >
              <img
                src={categoryImages[cat.id] || categoryImages['body-care']}
                alt={cat.name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <i className={`${cat.icon} text-accent-400 text-lg`} />
                  <h3 className="text-base font-heading font-semibold text-background-50">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-background-300/90">
                  {getCategoryCount(cat.id)} 款精品
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}